<script setup lang="ts">
// Authentication is now handled centrally by router guard
// No individual page-level authentication checks needed
</script>

<template>
  <div id="app-root">
    <router-view />
  </div>
</template>

<style>
:root {
  --content-max-width: 1100px;
  --mobile-padding: 1rem;
  --desktop-padding: 2rem;
}

#app-root {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}
</style>